/****************************************************
 * Module Name:  stonestatusMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import StonestatusProxy from "../../utility/proxy/manager/stonestatusProxy";
import AddStonestatusModal from "./addStonestatusModal";
import { DataGridPro, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, Tooltip } from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Constants from "../../utility/constants";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import NoPermission from "../common/noPermission";
import PageTitle from "../common/pageTitle";

export class StonestatusMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stonestatuss: [],

      stoneStatusOptions: [],
      showAddStonestatusModal: false,
      accesDenied: false,
      editOperation: false,
      sourceData: {},
      errorSnackbar: false,

      showStonestatusLoadSpinner: true,
      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid === Constants.PERMISSIONS.UTILITY_STONESTATUS
      ),
    };

    this.checkPermission()
  }

  componentDidMount() {
    PageTitle("UTILITY_STONESTATUS");
  }

  checkPermission = () => {
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      this.setState({
        accesDenied: true
      })
    } else {
      this.fetchStonestatusData(false);
    }
  }

  fetchStonestatusData = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showStonestatusLoadSpinner: true });
    StonestatusProxy.GetAllStonestatus((responseData) => {
      if (responseData) {
        this.setState({
          stonestatuss: responseData,
          showStonestatusLoadSpinner: false,
          stoneStatusOptions: Utility.getDistinctOptions(responseData, 'status')
        })
      } else {
        this.setState({ errorSnackbar: true, showStonestatusLoadSpinner: false })
      }
    }
    );
  };

  initialColumns = () => [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      type: 'number',
      align: "center",
    },
    {
      field: "status",
      headerName: "STONE STATUS",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "singleSelect",
      valueOptions: this.state.stoneStatusOptions,
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "description",
      headerName: "DESCRIP",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "edit",
      headerName: "EDIT",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              this.setState({
                showAddStonestatusModal: true,
                editOperation: true,
                sourceData: params.row,
              });
            }}
          >
            {" "}
            <BorderColorIcon color="primary" />
          </Box>
        );
      },
    },
  ];

  hideAddStonestatusModal = () => {
    this.setState({
      showAddStonestatusModal: false,
    });
  };

  handleValidation = (stonestatusData) => {
    //TODO do validation if needed here
    return true;
  };

  addStonestatus = (stonestatusData) => {
    this.setState({ loadingButton: true });
    if (this.state.editOperation) {
      //Updating Stonestatus, and once stonestatus is updated on call refresh the list of current stonestatuss
      StonestatusProxy.UpdateStonestatus(stonestatusData, (response) => {
        if (response) {
          this.fetchStonestatusData(true);
          this.setState({ loadingButton: false });
          //Hidding stonestatus modal
          this.hideAddStonestatusModal();
        } else {
          this.setState({ errorSnackbar: true });
          this.setState({ loadingButton: false });
        }
      });
    } else {
      //Creating new Stonestatus, and once stonestatus is created on call refresh the list of current stonestatuss
      StonestatusProxy.AddStonestatus(stonestatusData, (response) => {
        if (response) {
          this.fetchStonestatusData(true);
          this.setState({ loadingButton: false });
          //Hidding stonestatus modal
          this.hideAddStonestatusModal();
        } else {
          this.setState({ errorSnackbar: true });
          this.setState({ loadingButton: false });
        }
      });
    }
  };

  render() {
    const CustomToolbar = () => {
      return (
        <GridToolbarContainer
          sx={{
            display: "flex",
            alignItems: "center",
            marginHorizontal: "5px",
            "&.MuiDataGrid-toolbarContainer": {
              padding: "0px 4px !important",
            },
          }}
        >
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarExport />
          <Box sx={{ flexGrow: 1, display: { sm: "none", md: "block" } }} />
          {this.state.showStonestatusLoadSpinner ? (
            <CircularProgress size="1rem" />
          ) : (
            <Tooltip title="Reload List">
              <RefreshOutlinedIcon
                color="primary"
                fontSize="medium"
                onClick={() => this.fetchStonestatusData(true)}
                sx={{ cursor: "pointer" }}
              />
            </Tooltip>
          )}

          {Utility.isAddAllowed(this.state.local_Permission) ? (
            <Tooltip title="Add Stone Status">
              <Button
                color="info"
                variant="outlined"
                size="small"
                sx={{ ml: "5px" }}
                onClick={() =>
                  this.setState({
                    showAddStonestatusModal: true,
                    editOperation: false,
                    sourceData: {},
                  })
                }
                startIcon={<AddBoxOutlinedIcon size="large" />}
              >
                Stone Status
              </Button>
            </Tooltip>
          ) : null}

          <GridToolbarQuickFilter debounceMs={500} />
        </GridToolbarContainer>
      );
    }
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      return <NoPermission />
    }
    const rows = this.state.stonestatuss;
    const columns = Utility.isUpdateAllowed(this.state.local_Permission)
      ? this.initialColumns()
      : this.initialColumns().filter((col) => col.field !== "edit");
    return (
      <Box>
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={<Box>{Constants.APiFailErrorMessage}</Box>}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ errorSnackbar: false })}
          title="Failed"
        />
        <br />
        {this.state.showAddStonestatusModal ? (
          <AddStonestatusModal
            Show={true}
            handleClose={this.hideAddStonestatusModal}
            handleSave={this.addStonestatus}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            loading={this.state.loadingButton}
          />
        ) : (
          <Box />
        )}
        <Box px={1} sx={{ mt: 1 }}>
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "100%",
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              height: "85vh",
            }}
          >
            <DataGridPro
              disableRowSelectionOnClick={true}
              getRowHeight={() => "auto"}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "4px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "12px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "18px",
                },

                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              }}
              density="compact"
              slots={{ toolbar: CustomToolbar }}
              rows={rows}
              columns={columns}
              getRowId={(row) => row.id}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns status and traderName, the other columns will remain visible
                    id: false,
                  },
                },
                pagination: {
                  paginationModel: Constants.pageSize,
                },
              }}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              loading={this.state.showStonestatusLoadSpinner}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
        </Box>
      </Box>
    );
  }
}

export default StonestatusMaster;
